import React, { useContext } from 'react';
import { MxColumnType, MxColumnsType, FieldTable } from '@maxtropy/components';
import { PointContext, PointContextProps } from '../../../contextTypes';
import { getColumns } from './columns';
import { EdgeDeviceTemplatePoint } from './index';
import { DataPointType, DataProperty } from '../../../../../types';

interface ModbusPointBaseProps {
  fixed?: boolean;
  loading?: boolean;
  editColumns?: MxColumnsType<EdgeDeviceTemplatePoint>;
  dataPropertiesAll?: DataProperty[];
}

export const getIndexColumn = (fixed?: boolean): MxColumnType<EdgeDeviceTemplatePoint> => {
  return {
    title: '序号',
    width: 70,
    dataIndex: 'index',
    fixed: 'left',
    render: (_, record, index) => index + 1,
  };
};

const ModbusPointBase: React.FC<ModbusPointBaseProps> = props => {
  const { fixed, loading, editColumns } = props;

  const { dataSource, canAdjustField } = useContext(PointContext) as PointContextProps<EdgeDeviceTemplatePoint>;

  return (
    <FieldTable
      sticky
      loading={loading}
      scroll={{ y: 500 }}
      rowKey="id"
      cacheKey="modbusPoint"
      adjustField={canAdjustField}
      adjustWidth={canAdjustField}
      dataSource={dataSource?.filter(item => item.pointType === DataPointType.BASE_POINT)}
      columns={[
        getIndexColumn(fixed),
        ...getColumns(!canAdjustField ? [] : editColumns),
        ...(canAdjustField ? [] : editColumns || []),
      ]}
    />
  );
};

export default ModbusPointBase;
